import { Action } from '@ngrx/store';
import { NotificationBulkSendInterface } from 'app/notifications/models';

import { NotificationActionType } from './notification-action-type.enum';

export class SendNotifications implements Action {
  public readonly type: NotificationActionType = NotificationActionType.SendNotifications;

  constructor(public readonly payload?: NotificationBulkSendInterface) { }
}

export class SendNotificationsCompleted implements Action {
  public readonly type: NotificationActionType = NotificationActionType.SendNotificationsCompleted;

  constructor(public readonly payload?: number[]) { }
}

export class SendNotificationsFailed implements Action {
  public readonly type: NotificationActionType = NotificationActionType.SendNotificationsFailed;

  constructor(public readonly payload?: any) { }
}
